const StatisticsCard = ({ icon, title, value, subtitle, progress, subtitleHighlight }) => {
    return (
        <div className="border border-neutral-300 rounded-lg p-4">
            <strong className="text-neutral-700 flex justify-between items-center">
                <span className="sm:text-xs sm:pr-2">{title}</span>
                {icon}
            </strong>
            <h2 className="my-1">{value}</h2>
            {progress !== undefined ? (
                <div className="bg-neutral-200 h-2 rounded-md w-full">
                    <div
                        className="bg-primary h-2 rounded-md"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
            ) : (
                <p className="text-sm text-neutral-500">
                    {subtitle}{' '}
                    {subtitleHighlight && (
                        <span className="text-success font-semibold">{subtitleHighlight}</span>
                    )}
                </p>
            )}
        </div>
    );
};

export default StatisticsCard;
